mutation ProcessCaseRecordGrantCompliance($caseRecordId: ID!) {
  processCaseRecordGrantCompliance(input: { caseRecordId: $caseRecordId }) {
    success
  }
}
